import { StoreState } from 'state/types';

export const getPermissions = (state: StoreState) => state.permissions.permissions;
